import { render, staticRenderFns } from "./act-buy.vue?vue&type=template&id=a6a5dbbe&scoped=true&"
import script from "./act-buy.vue?vue&type=script&lang=js&"
export * from "./act-buy.vue?vue&type=script&lang=js&"
import style0 from "./act-buy.vue?vue&type=style&index=0&id=a6a5dbbe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a5dbbe",
  null
  
)

export default component.exports